import type { SpatialRectangle } from "./SpatialRectangle"

export type Media = {
  readonly trim_box: SpatialRectangle
  readonly media_box: SpatialRectangle
}
